const SvgCheckCircleFilledIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    fill="none"
    {...props}
  >
    <circle cx={7.5} cy={7} r={7} fill="#F79133" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.077}
      d="m5.379 7.388 1.156 1.156 3.087-3.088"
    />
  </svg>
);
export default SvgCheckCircleFilledIcon;
